import React from 'react';
import { PageLayout } from '../../components/shared/PageLayout';
import { Seo } from '../../components/shared/Seo';

const TermsConditionsPage: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org", "@type": "WebPage", "name": "Terms & Conditions - Device Doctor", "description": "Terms and Conditions for Device Doctor mobile repair services", "url": "https://devicedoctor.in/terms-conditions", "dateModified": "2025-01-01", "publisher": { "@type": "Organization", "name": "Device Doctor", "address": { "@type": "PostalAddress", "streetAddress": "Store no 1, Near Nakshatra Jewellery, Vyttila Jn", "addressLocality": "Kochi", "addressRegion": "Kerala", "postalCode": "682019", "addressCountry": "IN" } }
  };
  
  return (
    <PageLayout>
      <Seo
        title="Terms & Conditions - Device Doctor Kochi | Mobile Repair Service Agreement"
        description="Terms and Conditions for Device Doctor mobile repair services in Kochi. Service agreement, warranty terms, customer responsibilities, and repair policies. Read before using our services."
        keywords="terms conditions, device doctor terms, mobile repair agreement, service terms kochi, repair warranty terms"
        structuredData={structuredData}
      />
      
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Terms &amp; Conditions</h1>
            <p className="text-xl text-blue-100">
              Please read these terms carefully before using our mobile repair services.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-600 mb-6"><strong>Last Updated:</strong> January 2025</p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Service Agreement</h2>
              <p>By using our services, you agree to our diagnosis process, repair terms, and payment policies. We agree to perform services to the best of our ability.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">2. Customer Responsibilities</h2>
              <p>You are responsible for backing up your device data. We are not liable for any data loss. Please remove SIM cards and memory cards before service.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">3. Warranty</h2>
              <p>We provide a 1-month warranty on all repairs, covering the specific parts replaced and the workmanship. This warranty does not cover accidental damage, water damage, or issues unrelated to the original repair.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">4. Device Abandonment</h2>
              <p>Devices not collected within 90 days of repair completion will be considered abandoned and may be recycled or sold to recover costs.</p>
              <h2 className="text-2xl font-bold text-gray-900 my-4">5. Contact Information</h2>
              <p>For any questions regarding our terms, please contact us at info@devicedoctor.com.</p>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default TermsConditionsPage;
export { TermsConditionsPage };